import { Component } from '@angular/core';
import { LegalWheelSection } from '../../shared/ui/legal-wheel/legal-wheel.component';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: 'termsConditions.component.html'
})
export class TermsConditionsComponent {
  lastUpdated = 'September 2026';

  sections: LegalWheelSection[] = [
    {
      title: '1. What VOWEL provides',
      body: `<p>
          VOWEL is a visitor, staff, resident, service-provider and vehicle management platform that lets
          properties register accounts, configure check-in/check-out workflows, bind devices and kiosks,
          run reports, and receive notifications related to on-site activity and security events.
        </p>`,
    },
    {
      title: '2. Accounts and access',
      body: `<ul>
          <li>Accounts are provisioned per property, with roles (e.g. Account Admin, Web Admin, Device Admin, Resident, Employee) that determine what a user can see and do.</li>
          <li>You are responsible for keeping your login credentials confidential and for all activity that occurs under your account.</li>
          <li>Account administrators are responsible for the accuracy of data entered for their property and for granting access only to authorized personnel.</li>
          <li>We may suspend or terminate access that we reasonably believe is unauthorized, abusive, or in breach of these Terms.</li>
        </ul>`,
    },
    {
      title: '3. Acceptable use',
      body: `<p>You agree not to use VOWEL to:</p>
        <ul>
          <li>Collect or process visitor, staff, or vehicle data for any purpose other than legitimate property access control, security, and reporting.</li>
          <li>Attempt to access accounts, properties, or data you are not authorized to view.</li>
          <li>Interfere with or disrupt the platform, its APIs, or bound devices (e.g. kiosks, entry-point hardware).</li>
          <li>Upload unlawful, harmful, or infringing content, including through photos or free-text fields.</li>
        </ul>`,
    },
    {
      title: '4. Data you enter into the platform',
      body: `<p>
          As between VOWEL and the property account, the property account owns the visitor, staff, resident
          and vehicle records it enters or collects through the platform. VOWEL processes this data solely
          to provide the service, as described in our Privacy Policy.
          The property account is responsible for having a lawful basis to collect and retain the
          information it captures about its own visitors and staff.
        </p>`,
    },
    {
      title: '5. Availability',
      body: `<p>
          We aim to keep VOWEL available and reliable, including for time-sensitive functions like check-in
          and panic notifications, but the platform is provided "as is" and "as available" without a
          guarantee of uninterrupted or error-free operation. Scheduled maintenance, connectivity issues on
          bound devices, or factors outside our control may affect availability from time to time.
        </p>`,
    },
    {
      title: '6. Limitation of liability',
      body: `<p>
          To the fullest extent permitted by law, VOWEL is not liable for indirect, incidental, or
          consequential loss arising from use of the platform, including loss resulting from inaccurate
          data entered by a property's own users, or from decisions made on the basis of platform reports
          or notifications. Nothing in these Terms limits liability that cannot lawfully be limited.
        </p>`,
    },
    {
      title: '7. Changes to the service or these Terms',
      body: `<p>
          We may update VOWEL's features and these Terms over time. Where changes are material, we will
          reflect this by updating the "Last updated" date above. Continued use of the platform after an
          update constitutes acceptance of the revised Terms.
        </p>`,
    },
    {
      title: '8. Termination',
      body: `<p>
          A property account may stop using VOWEL at any time. We may suspend or terminate an account for
          breach of these Terms, non-payment where applicable, or where continued access poses a security
          risk to the platform or other accounts.
        </p>`,
    },
    {
      title: '9. Contact',
      body: `<p>
          Questions about these Terms can be sent to <a href="mailto:di.support@compulynx.com">di.support@compulynx.com</a>.
        </p>`,
    },
  ];
}
